/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionPatchRequestSchema = z.object({
  description: z.string().nullish(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']).nullish(),
  locationId: z.int().nullish(),
  name: z.string().nullish(),
  roleId: z.int().nullish(),
  skillIds: z.array(z.int().nullable()).nullish(),
});
